import axios from "axios";

export const enviarCorreo = async (entidad) => {


    let data = JSON.stringify(entidad);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
      //  url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/ebc3e431-a223-4be7-aaaa-7fe44f06b919', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/ebc3e431-a223-4be7-aaaa-7fe44f06b919',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
            console.log(error);
        });


}